// extracted by mini-css-extract-plugin
module.exports = {"buttonLogo":"ButtonLogo_buttonLogo__Ju_vj","logo":"ButtonLogo_logo__u9Fgp","logoInverted":"ButtonLogo_logoInverted__2lR97"};